<div [hidden]="pageData.viewMode != 'LIST'">
   <div class="row">
      <div class="col s6">
         <h4 class="card-title">Templates</h4>
         <p *ngIf="pageData.viewMode=='LIST'">
            {{pageData.records.length}} template(s) in total.
         </p>
      </div>
      <div class="col s6 right-align">
         <a (click)="recordAdd()" class="waves-effect waves-light btn gradient-45deg-red-pink">
            <i class="material-icons left">add</i>Template
         </a>
      </div>
      <div class="col s12 m12 l12" *ngIf="pageData.records.length>0">
         <table>
            <tr>
               <th></th>
               <th>Code</th>
               <th>Name</th>
               <th>Subject</th>
               <td></td>
            </tr>
            <tr *ngFor="let rec of pageData.records; let iRec=index;">
               <td>{{iRec+1}}</td>
               <td>{{rec.templateCode}}</td>
               <td>{{rec.templateName}}</td>
               <td>{{rec.subject}}</td>
               <td class="center" style="padding:5px;">
                  <a (click)="recordEdit(rec)" class="btn-floating waves-effect waves-light gradient-45deg-light-blue-cyan" style="margin-right: 2px;">
                     <i class="material-icons">edit</i>
                  </a>
                  <a (click)="recordDelete(rec)" class="btn-floating waves-effect waves-light gradient-45deg-red-pink">
                     <i class="material-icons">clear</i>
                  </a>
               </td>
            </tr>
         </table>
      </div>
   </div>
</div>
<div [hidden]="pageData.viewMode != 'FORM'">
   <div class="row">
      <div class="col s12">
         <h4 class="card-title">Add Template</h4>
      </div>
      <div class="col s12">
         <form class="col s12">
            <div class="row">
               <div class="input-field col s12">
                  <input [(ngModel)]="oRec.templateCode" placeholder="Template Code" name="txtTemplateCode" id="txtTemplateCode" type="text">
                  <label for="txtTemplateCode" class="active">Template Code</label>
               </div>
            </div>
            <div class="row">
               <div class="input-field col s12">
                  <input [(ngModel)]="oRec.templateName" placeholder="Template Name" name="txtTemplateName" id="txtTemplateName" type="text">
                  <label for="txtTemplateName" class="active">Template Name</label>
               </div>
            </div>
            <div class="row">
               <div class="input-field col s12">
                  <input [(ngModel)]="oRec.subject" placeholder="Subject" name="txtSubject" id="txtSubject" type="text">
                  <label for="txtSubject" class="active">Subject</label>
               </div>
            </div>
            <div class="row">
               <div class="input-field col s12">
                  <!-- <angular-editor [(ngModel)]="oRec.body" name="edBody" [config]="editorConfig"></angular-editor> -->
               </div>
            </div>
            <div class="row">
               <div class="input-field col s12">
                  <button (click)="viewList()" class="btn brown lighten-1 waves-effect waves-light tatt-btn-right-margin" type="submit" name="action">Cancel
                  </button>
                  <button (click)="recordSave()" class="btn cyan waves-effect waves-light" type="submit" name="action">Submit
                     <i class="material-icons right">send</i>
                  </button>
               </div>
            </div>
         </form>
      </div>
   </div>
</div>
   